exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Project/posSystem/src/app/pos/auth/add-user/add-user.component.css
// module id = ../../../../../src/app/pos/auth/add-user/add-user.component.css
// module chunks = main